/* unplugin-vue-components disabled */import script from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"

import "./Breadcrumb.vue?vue&type=style&index=0&id=1feba8fc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1feba8fc"]])

export default __exports__